import { AmbassadorToolState } from 'services/ambassador';
import { BiddingData } from '../bidding_store/types';

/* eslint-disable camelcase */
export enum ProfileTypes {
  SHOW_REQUEST = '@profile/SHOW_REQUEST',
  SHOW_SUCCESS = '@profile/SHOW_SUCCESS',
  SHOW_FAILURE = '@profile/SHOW_FAILURE',
  LOGOUT_REQUEST = '@profile/LOGOUT_REQUEST',
  LOGOUT_SUCCESS = '@profile/LOGOUT_SUCCESS',
  LOGOUT_FAILURE = '@profile/LOGOUT_FAILURE',
  REFRESH_PROFILE_REQUEST = '@profile/REFRESH_PROFILE_REQUEST',
  REFRESH_PROFILE_SUCCESS = '@profile/REFRESH_PROFILE_SUCCESS',
  REFRESH_PROFILE_FAILURE = '@profile/REFRESH_PROFILE_FAILURE',
  REGISTER_REQUEST = '@profile/REGISTER_REQUEST',
  REGISTER_SUCCESS = '@profile/REGISTER_SUCCESS',
  REGISTER_FAILURE = '@profile/REGISTER_FAILURE',
  PASSWORD_NEW_REQUEST = '@profile/PASSWORD_NEW_REQUEST',
  PASSWORD_NEW_SUCCESS = '@profile/PASSWORD_NEW_SUCCESS',
  PASSWORD_NEW_FAILURE = '@profile/PASSWORD_NEW_FAILURE',
  PASSWORD_EDIT_REQUEST = '@profile/PASSWORD_EDIT_REQUEST',
  PASSWORD_EDIT_SUCCESS = '@profile/PASSWORD_EDIT_SUCCESS',
  PASSWORD_EDIT_FAILURE = '@profile/PASSWORD_EDIT_FAILURE',
  PASSWORD_UPDATE_REQUEST = '@profile/PASSWORD_UPDATE_REQUEST',
  PASSWORD_UPDATE_SUCCESS = '@profile/PASSWORD_UPDATE_SUCCESS',
  PASSWORD_UPDATE_FAILURE = '@profile/PASSWORD_UPDATE_FAILURE',
  INVITATION_REQUEST = '@profile/INVITATION_REQUEST',
  INVITATION_SUCCESS = '@profile/INVITATION_SUCCESS',
  INVITATION_FAILURE = '@profile/INVITATION_FAILURE',
  INVITATION_UPDATE_REQUEST = '@profile/INVITATION_UPDATE_REQUEST',
  INVITATION_UPDATE_SUCCESS = '@profile/INVITATION_UPDATE_SUCCESS',
  INVITATION_UPDATE_FAILURE = '@profile/INVITATION_UPDATE_FAILURE',
  UPDATE_STORE_FIELDS = '@profile/UPDATE_STORE_FIELDS',
  UPDATE_CURRENT_COMPANY = '@profile/UPDATE_CURRENT_COMPANY',
  UPDATE_SELECTED_COMPANIES = '@profile/UPDATE_SELECTED_COMPANIES',
  VIEW_MODAL = '@profile/VIEW_MODAL',
  SET_AVATAR_URL = '@profile/SET_AVATAR_URL',
}

export interface RepresentedTypes {
  id: number;
  nome_fantasia: string;
  razao_social: string;
  cnpj: string;
  paralisado: boolean;
  sale_situation_name: string;
  servicos_liberados?: boolean;
}

export interface CurrentCompanyTypes {
  [key: string]: number;
}

export interface SelectedCompaniesTypes {
  [key: string]: number[];
}

export interface ProfileData {
  id: number;
  clientId: number;
  ddd_cellphone: string;
  cellphone: string;
  cpf: string;
  cnpj: string;
  name: string;
  contact_name?: string;
  admin?: boolean;
  email: string;
  avatar_url?: string | null;
  permissions: Array<string>;
  isSigned: boolean;
  in_sample: boolean;
  in_analysis: boolean;
  alfa_tester: boolean;
  beta_tester: boolean;
  ambassador: {
    invited: boolean;
    member: boolean;
    /** Cliente assinante do boletim: sem isso o embaixador não testa nenhuma ferramenta. */
    subscriber?: boolean;
    /** Situação de cada ferramenta do programa; vazio para quem não é embaixador. */
    tools?: AmbassadorToolState[];
  };
  modal: boolean;
  can_use_my_documents: boolean;
  has_documents_company: boolean;
  can_use_conlicitaseg: boolean;
  is_only_conlicitaseg: boolean;
  fidelize: {
    is_fidelize: boolean;
    biddings: Array<BiddingData> | null;
  };
  robo_access: boolean;
  sale_situation: string;
  conlicitantes_vip_banner: boolean;
  responsible: string;
  enable_captcha: boolean;
  partner_user: boolean;
  paralyzed: boolean;
  first_bulletin_unread: boolean;
  consultant_login: boolean;
  company_data: {
    data: {
      id: number;
      cnpj: string;
      razao_social: string;
      nome_fantasia: string;
      inscricao_estadual: string;
      ddd_telefone: string;
      numero_telefone: string;
      email: string;
      website: string;
      endereco: string;
      numero: string;
      complemento: string;
      bairro: string;
      cep: string;
      estado_id: number;
    };
    estado: string;
    cidade: string;
  };
  loginStatus: {
    text: string;
    class: string;
    show: boolean;
  };
  representant: boolean;
  represented: Array<RepresentedTypes>;
  currentCompany: CurrentCompanyTypes;
  selectedCompanies: SelectedCompaniesTypes;
  password_message: string;
  resource_name: string;
  resource_email: string;
  message_success_password: string;
  can_use_dr_licita: boolean;
  // Modo Atendimento do Dr. Licita (flag própria no Rails)
  dr_licita_atendimento: boolean;
  validate_services: {
    gerenciar_documentos: boolean;
    monitorar_chat: boolean;
    assinatura_digital: boolean;
    robo: boolean;
    conlicitago: boolean;
    course_iaml: boolean;
    dr_licita: boolean;
  };
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface RefreshRequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface RegisterRequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface PasswordNewRequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface ProfileState {
  readonly profile: ProfileData;
  readonly request: RequestState;
  readonly refresh_request: RefreshRequestState;
  readonly register_request: RegisterRequestState;
  readonly password_new: PasswordNewRequestState;
  readonly password_edit: PasswordNewRequestState;
  readonly password_update: PasswordNewRequestState;
}
